import React, {Component} from "react";
import Typography from '@mui/material/Typography';
import theme from "../../theme";
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import { Link } from 'react-router-dom'
import { Trans } from "react-i18next";

const styles = {
    root: {
        // flexGrow: 1,
        // zIndex: 1,
        overflow: 'hidden',
        // display: 'flex',
        // height: '100%',
    },
    title: {
        padding: '20px 0 18px 0',
        [theme.breakpoints.down('xs')]: {
            textAlign: 'center',
        },
    },
    subtitle: {
        color: '#004653',
        [theme.breakpoints.down('xs')]: {
            textAlign: 'center',
        },
    },
    wrapper: {
        display: 'flex',
            justifyContent: 'center',
            marginTop: '10%',
        // },
    },
    paper: {
        boxSizing: 'content-box',
        maxWidth: 270,
        padding: '20px 19px 23px 19px',
        display: 'flex',
        flexDirection: 'column',
        marginBottom: 44,
        marginRight: 34,
        [theme.breakpoints.down('xs')]: {
            marginRight: 0,
        },
    },
    button: {
        marginTop: 30,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
}

class NoDevice extends Component {

    constructor(props) {
        super(props);


        this.state = {
            device: props.currentDevice
        }
    }


    render() {
        const  {classes}  = this.props;

        return (
            <div style={styles.root}>
                <Typography style={styles.title} variant="headline">{this.props.title}</Typography>
                <div style={styles.wrapper}>
                    <Paper style={styles.paper}>
                        <Typography variant="h5">
                            <Trans i18nKey="NoDevicesScreen.heading"></Trans>
                        </Typography>
                        <br />
                        <Typography variant="subtitle1">
                            <Trans i18nKey="NoDevicesScreen.subheading"></Trans>
                        </Typography>
                        <div style={styles.button}>
                            <Link to="/devices" style={{ textDecoration: 'none' }}>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    style={{ color: theme.palette.primary.dark }}
                                >
                                    <Trans i18nKey="NoDevicesScreen.button_open_devices"></Trans>
                                </Button>
                            </Link>

                        </div>
                    </Paper>
                </div>
            </div>
         )
    }
}


//NoDevice = withStyles(styles)(NoDevice)

export default NoDevice;
